export enum StorageKeyEnum {
  tokenStorageKey = '___PLUGIN_TOKEN_KEY___',
  refreshTokenStorageKey = '___PLUGIN_TOKEN2_KEY___',
  tokenTtlStorageKey = '___PLUGIN_TOKEN3_KEY___',
  projectId = '___PROJECT_ID___',
  projectName = '___PROJECT_NAME___',
}
